import React, { ReactNode } from 'react';
import styled from 'styled-components';

const AdBoxContainer = styled.div`
  background: ${({ theme }) => theme.colors.primary};
  padding: 40px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  p {
    line-height: 2;
    text-align: center;
  }
  a {
    color: white;
    text-decoration: none;
  }
`;
const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  h1 {
    text-transform: uppercase;
  }
`;

type RentNowCard = {
  children: ReactNode;
};
const RentNowCard = ({ children }: RentNowCard) => {
  return (
    <AdBoxContainer>
      <TextContent>
        <h1>Start Renting Now</h1>
        <p>
          Make some extra cash by Renting things in your community. Go on, it&apos;s quick and easy.
        </p>
      </TextContent>
      {children}
    </AdBoxContainer>
  );
};
export default RentNowCard;
